// Mock data for OLD2NEW Classic Car Restoration

export const services = [
  {
    id: 1,
    title: 'Mustang Fastback Conversions',
    description: 'Expert conversion services to transform your Mustang into a classic fastback design with precision and authenticity.',
    icon: 'Wrench'
  },
  {
    id: 2,
    title: 'Rust Repair & Body Metal Work',
    description: 'Complete rust removal and body metal restoration to bring your classic car back to its original glory.',
    icon: 'Hammer'
  },
  {
    id: 3,
    title: 'Patina Restoration/Treatment',
    description: 'Preserve the authentic aged look of your classic car while protecting it from further deterioration.',
    icon: 'Paintbrush'
  },
  {
    id: 4,
    title: 'Window Installation',
    description: 'Professional installation of original or replacement windows with proper sealing and fit.',
    icon: 'Frame'
  },
  {
    id: 5,
    title: 'Body Gap Alignment',
    description: 'Precision alignment of doors, hoods, and trunk to factory specifications for that perfect fit.',
    icon: 'Ruler'
  },
  {
    id: 6,
    title: 'Engine Swaps',
    description: 'Complete engine replacement and upgrade services with modern performance options.',
    icon: 'Cog'
  },
  {
    id: 7,
    title: 'Auto Rewiring',
    description: 'Full electrical system restoration and modern wiring upgrades for reliability and safety.',
    icon: 'Cable'
  },
  {
    id: 8,
    title: 'Final Assembly',
    description: 'Meticulous final assembly and detailing to deliver your restored classic car ready to drive.',
    icon: 'CheckCircle'
  }
];

export const gallery = [
  {
    id: 1,
    title: '1971 Camaro SS',
    before: 'https://customer-assets.emergentagent.com/job_vintage-auto-1/artifacts/8pribzkb_IMG_9300.jpeg',
    after: 'https://customer-assets.emergentagent.com/job_vintage-auto-1/artifacts/w5a5p70n_71_Camaro_SS_Black_Engine.jpeg',
    description: 'LS3 engine swap with complete engine bay restoration',
    year: '2024',
    status: 'completed'
  },
  {
    id: 2,
    title: '1972 GMC Long Horn',
    before: 'https://customer-assets.emergentagent.com/job_vintage-auto-1/artifacts/qv8pce48_IMG_6140.jpeg',
    after: 'https://customer-assets.emergentagent.com/job_vintage-auto-1/artifacts/j90ekxrh_IMG_6777.jpeg',
    description: 'Blueprint Stroker 400 build delivering 511 HP with complete rewiring',
    year: '2024',
    status: 'completed'
  }
];

export const testimonials = [
  {
    id: 7,
    name: 'Beach Gypsy Classics',
    rating: 5,
    review: 'Old to new are the absolute best with classics! Great service and very professional. They have worked on our 1956 Thunderbird, 1966 mustang, and our 1961 corvette! Always reasonable with pricing and high quality work. They also stand by the work. Had to bring one back for adjustments and they honored the work made the adjustment and didn\'t charge us to have things adjusted. They are honest and really know classics! Highly recommend !!',
    source: 'Google',
    date: 'May 2026'
  },
  {
    id: 6,
    name: 'Benny Shipp',
    rating: 5,
    review: 'Old 2 New got me right. Had a gen 2 Camaro sitting for 10 years….. I towed it to the shop on a Wednesday …. And was on the road that same Friday. They were very helpful in planning out future work I want to do as well …. Gave me multiple options on suspension work, which we\'ve tentatively scheduled for July. Good guys. Last guy I had work on my car had my car for an entire year LOL… so it was day and night compared to that experience. I could shop price all day long… but getting things done quick and properly by knowledgeable mechanics is what was important to me. Highly recommend.',
    source: 'Google',
    date: 'May 2026'
  },
  {
    id: 5,
    name: 'Seth McCarty',
    rating: 5,
    review: 'Nick is the best! Super informative and helpful he even puts in the extra effort to make sure you\'re safe, which is very important to me. I\'ll definitely be coming back! Glad I came to you, definitely made a friend!',
    source: 'Google',
    date: 'May 2026'
  },
  {
    id: 1,
    name: 'David N.',
    rating: 5,
    review: 'Been having a great experience with Nick taking my \'68 C10 from old to new! Nick\'s craftsmanship and service is second to none...high quality work at a rapid pace. I will be bringing all my projects to him because I know it will get done right the first time and back on the road quickly. Very grateful to have found Old2New and look forward to many more builds in the future....Highly recommend!!',
    source: 'Yelp',
    date: 'December 2025'
  },
  {
    id: 2,
    name: 'Joseph A.',
    rating: 5,
    review: 'Old 2 new is currently working on my 1957 Chevy truck and I can\'t not be anymore excited about the work he had already put in. He is very good on keeping you in the loop by sending you updated photos of his progress and phone calls. If you\'re looking for someone to restore your classic or even just a small SERVICE at a fair prices with quality work, he gots it covered. I guaranteed you will not be disappointed. He is a very knowledgeable and respectful and I am glad I found him and trust him on building my dad\'s old truck. Nick you rock brother!',
    source: 'Yelp',
    date: 'December 2025'
  },
  {
    id: 3,
    name: 'Cal B.',
    rating: 5,
    review: 'For 14 years I\'ve had a front row seat to Nick\'s professional car journey. From dirty little dives with no support to fabulous multi million dollar boutiques with formula one engineers. He has taken his Wyo Tech education to another level by teaching himself to build high end motors and fabricate everything from dashboard A/C louvers to chassis and total body fabrication. He grew up in a motor shop called The Lab. His inspiration for cars is his entire focus. His failures are his success because he won\'t quit until it\'s perfect. Nick is truly a master of his trade.',
    source: 'Yelp',
    date: '1 year ago'
  },
  {
    id: 4,
    name: 'CJ D.',
    rating: 5,
    review: 'Nick, owner and operator at Old2New is an absolute wizard. I had the opportunity to have my Chevy C10 worked on by Nick. I had been following his instagram page for some time and appreciated his attention to detail following a few of his projects. He treated my rusty little truck with the same care as one of his one off builds. Communication was great with updates almost daily either through text, phone calls, or pictures. There were a few problems with the truck that I didn\'t know of and he addressed them for me. You can definitely trust his expertise. Thanks Nick! I look forward to getting my Caddy under the knife and back on the road. You\'re the man!',
    source: 'Yelp',
    date: 'December 2024'
  }
];

export const stats = [
  { label: 'Years Experience', value: '15+' },
  { label: 'Cars Restored', value: '200+' },
  { label: 'Happy Clients', value: '150+' },
  { label: 'Awards Won', value: '12' }
];